import { getToken } from '../../helpers/helpers';

export const getUsersPending = () => {
    return {
        type: 'GET_USERS_PENDING'
    }
};

export const getUsersSuccess = (users, page, numberOnPage, pageCount, usersCount) => {
    return {
        type: 'GET_USERS_SUCCESS',
        users,
        page,
        numberOnPage,
        pageCount,
        usersCount
    }
};

export const usersError = error => {
    return {
        type: 'USERS_ERROR',
        error: error
    }
};

export const getUsers = config => {
    const {search = '', page = 1, numberOnPage = 10, userId = ''} = config;
    const params = `number_on_page=${numberOnPage}${page ? '&page=' + page : ''}${search ? '&search=' + search : ''}`

    return dispatch => {
        dispatch(getUsersPending());

        fetch(`${process.env.REACT_APP_API_URL}/ipdad/user_list?${params}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': getToken(),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                } else {
                    dispatch(usersError(`Error: ${res.status} ${res.statusText}`));
                }
            })
            .then(res => {
                // dispatch(getUsersSuccess(res.users.sort((a, b) => a.lastName.localeCompare(b.lastName))));
                dispatch(getUsersSuccess(res.users, res.page, res.numberOnPage, res.pageCount, res.userCount));
                if(userId && userId !== -1) {
                    dispatch(selectUser(res.users.find(x => x.id === userId)));
                }
                if(userId && userId === -1) {
                    dispatch(selectUser(res.users.sort((a, b) => a.id - b.id)[res.users.length - 1]));
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const selectUser = user => {
    return {
        type: 'SELECT_USER',
        selected: user
    };
};

export const addUserSuccess = () => {
    return {
        type: 'ADD_USER_SUCCESS'
    }
};

export const addUser = (userData, closeForm) => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/custom/users/add_user`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('ipsadToken'),
            },
            body: JSON.stringify(userData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(addUserSuccess());
                    dispatch(getUsers(-1));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(usersError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const editUser = userData => {

    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/custom/users/update_user_profile`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('agronetToken'),
            },
            body: JSON.stringify(userData)
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getUsers(userData.id));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(usersError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const deleteUser = id => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/ipsad/delete_user/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('ipsadToken'),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getUsers());
                    dispatch(selectUser({}));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(usersError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};

export const clearUserDeviceIds = id => {
    return dispatch => {
        fetch(`${process.env.REACT_APP_API_URL}/ipsad/clear_device_ids_list/${id}`, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': sessionStorage.getItem('ipsadToken'),
            }
        })
            .then(res => {
                if (res.status === 200) {
                    dispatch(getUsers());
                    dispatch(selectUser({}));
                } else {
                    return res.json();
                }
            })
            .then(res => res ? dispatch(usersError(`Error ${res.status}: ${res.message}`)) : null)
            .catch(err => {
                console.log('ERROR', err);
            })
    }
};
